module.exports = __webpack_public_path__ + "img/PM10mg.b53ba5b7.png";